<template>
  <div class="ks-budget-container">
    <!-- 数据更新时间 -->
    <div class="query-time" v-if="queryTime">
      <span>数据更新时间：{{ queryTime }}</span>
      <el-button type="primary" size="mini" icon="el-icon-refresh" @click="fetchReport" :loading="loading" style="margin-left: 12px;">
        刷新
      </el-button>
    </div>

    <!-- 汇总卡片 -->
    <div class="summary-cards">
      <el-card class="summary-card">
        <div class="card-label">今日消耗</div>
        <div class="card-value">{{ summary.totalCost | formatMoney }} 元</div>
      </el-card>
      <el-card class="summary-card">
        <div class="card-label">昨日消耗</div>
        <div class="card-value">{{ summary.totalYesterdayCost | formatMoney }} 元</div>
      </el-card>
      <el-card class="summary-card">
        <div class="card-label">总激活</div>
        <div class="card-value">{{ summary.totalActivation }} 个</div>
      </el-card>
      <el-card class="summary-card">
        <div class="card-label">平均激活成本</div>
        <div class="card-value">{{ summary.avgActivationCost | formatMoney }} 元</div>
      </el-card>
    </div>

    <!-- 账户列表表格 -->
    <div class="table-section">
      <el-table
        :data="accountList"
        stripe
        border
        v-loading="loading"
        empty-text="暂无账户数据"
        :row-class-name="rowClassName"
        style="width: 100%">
        <el-table-column prop="accountId" label="账户ID" width="110" align="center" />
        <el-table-column prop="accountName" label="账户名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="totalCost" label="今日消耗(元)" width="140" align="right">
          <template slot-scope="scope">
            {{ scope.row.totalCost | formatMoney }}
          </template>
        </el-table-column>
        <el-table-column prop="yesterdayCost" label="昨日消耗(元)" width="140" align="right">
          <template slot-scope="scope">
            {{ scope.row.yesterdayCost | formatMoney }}
          </template>
        </el-table-column>
        <el-table-column label="日预算(元)" width="140" align="right">
          <template slot-scope="scope">
            {{ scope.row.dailyBudget != null ? (scope.row.dailyBudget | formatMoney) : '—' }}
          </template>
        </el-table-column>
        <el-table-column prop="activation" label="激活数" width="100" align="center" />
        <el-table-column prop="activationCost" label="激活成本(元)" width="130" align="right">
          <template slot-scope="scope">
            {{ scope.row.activationCost | formatMoney }}
          </template>
        </el-table-column>
        <el-table-column prop="conversionCost" label="转化成本(计费时间)(元)" width="180" align="right">
          <template slot-scope="scope">
            {{ scope.row.conversionCost | formatMoney }}
          </template>
        </el-table-column>
        <el-table-column prop="totalBalance" label="账户余额(元)" width="140" align="right">
          <template slot-scope="scope">
            {{ scope.row.totalBalance | formatMoney }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openBudgetDialog(scope.row)">
              预算
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 预算编辑弹窗 -->
    <el-dialog
      :title="'修改日预算 - ' + currentAccount.accountName"
      :visible.sync="dialogVisible"
      width="480px"
      :close-on-click-modal="false"
      @closed="resetBudgetForm">
      <el-form :model="budgetForm" label-width="80px" v-loading="budgetLoading">
        <el-form-item v-for="(day, index) in dayLabels" :key="index" :label="day">
          <el-input
            v-model.number="budgetForm.schedule[index]"
            type="number"
            :min="0"
            placeholder="请输入预算">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveBudget" :loading="saving">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

const DAY_LABELS = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']

export default {
  name: 'KsBudget',

  data() {
    return {
      queryTime: '',
      summary: {
        totalCost: 0,
        totalYesterdayCost: 0,
        totalActivation: 0,
        avgActivationCost: 0
      },
      accountList: [],
      loading: false,

      // 预算弹窗
      dialogVisible: false,
      budgetLoading: false,
      saving: false,
      currentAccount: {},
      budgetForm: {
        schedule: [0, 0, 0, 0, 0, 0, 0]
      },
      dayLabels: DAY_LABELS
    }
  },

  filters: {
    formatMoney(val) {
      if (val == null || val === '') return '0.00'
      const num = Number(val)
      if (isNaN(num)) return '0.00'
      return num.toFixed(2)
    }
  },

  created() {
    this.fetchReport()
  },

  methods: {
    // ========== 行样式：消耗超过日预算80%标红 ==========
    rowClassName({ row }) {
      const budget = Number(row.dailyBudget)
      const cost = Number(row.totalCost)
      // 日预算为空/NaN/为0时不判断
      if (!budget || budget <= 0) return ''
      if (!isNaN(cost) && cost > budget * 0.8) {
        return 'row-warning'
      }
      return ''
    },

    // ========== 获取消耗报表 ==========
    fetchReport() {
      this.loading = true
      axios.get('https://wcry.zjwec.cn/ks/report')
        .then(res => {
          const data = res.data
          if (data && data.code === 200 && data.data) {
            const body = data.data
            this.queryTime = body.queryTime || ''
            if (body.summary) {
              this.summary = {
                totalCost: body.summary.totalCost || 0,
                totalYesterdayCost: body.summary.totalYesterdayCost || 0,
                totalActivation: body.summary.totalActivation || 0,
                avgActivationCost: body.summary.avgActivationCost || 0
              }
            }
            this.accountList = body.accounts || []
          } else {
            this.$message.warning(data.msg || '获取数据失败')
          }
        })
        .catch(() => {
          this.$message.error('获取消耗数据失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // ========== 打开预算弹窗 ==========
    openBudgetDialog(account) {
      this.currentAccount = account
      this.dialogVisible = true
      this.budgetLoading = true

      axios.get('https://wcry.zjwec.cn/ks/budget/' + account.accountId)
        .then(res => {
          const data = res.data
          if (data && data.code === 200 && data.data && data.data.result === 1) {
            const schedule = data.data.budget_schedule || []
            // 厘转元：÷1000
            const yuanList = schedule.map(v => (v / 1000).toFixed(2))
            this.budgetForm.schedule = yuanList.map(v => Number(v))
          } else {
            this.$message.warning(data.msg || '获取预算数据失败')
            // 失败时用默认值0
            this.budgetForm.schedule = [0, 0, 0, 0, 0, 0, 0]
          }
        })
        .catch(() => {
          this.$message.error('获取预算数据失败，请稍后重试')
          this.budgetForm.schedule = [0, 0, 0, 0, 0, 0, 0]
        })
        .finally(() => {
          this.budgetLoading = false
        })
    },

    // ========== 保存预算 ==========
    saveBudget() {
      // 校验输入
      const schedule = this.budgetForm.schedule
      for (let i = 0; i < schedule.length; i++) {
        const val = schedule[i]
        if (val == null || val === '' || Number(val) < 0) {
          this.$message.warning(`请输入合法的${this.dayLabels[i]}预算（≥0）`)
          return
        }
      }

      // 转为数字数组（元）
      const body = {
        budgetSchedule: schedule.map(v => Number(v))
      }

      this.saving = true
      axios.put('https://wcry.zjwec.cn/ks/budget/' + this.currentAccount.accountId, body)
        .then(res => {
          const data = res.data
          if (data && data.code === 200) {
            this.$message.success('修改成功')
            this.dialogVisible = false
            // 刷新表格数据
            this.fetchReport()
          } else {
            this.$message.error(data.msg || '修改失败')
          }
        })
        .catch(() => {
          this.$message.error('修改预算失败，请稍后重试')
        })
        .finally(() => {
          this.saving = false
        })
    },

    // ========== 重置预算表单 ==========
    resetBudgetForm() {
      this.currentAccount = {}
      this.budgetForm.schedule = [0, 0, 0, 0, 0, 0, 0]
    }
  }
}
</script>

<style scoped>
.ks-budget-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
}

/* 更新时间行 */
.query-time {
  margin-bottom: 16px;
  font-size: 14px;
  color: #606266;
}

/* 汇总卡片 */
.summary-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.summary-card {
  flex: 1;
  text-align: center;
}

.summary-card .card-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.summary-card .card-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

/* 表格区域 */
.table-section {
  background: #fff;
  padding: 0;
}

/* 消耗超过日预算80%的行标红 */
/deep/ .row-warning {
  color: #f56c6c !important;
}
/deep/ .row-warning td {
  color: #f56c6c !important;
  background-color: #fef0f0 !important;
}
/deep/ .el-table__body tr.row-warning {
  background-color: #fef0f0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ks/ksBudget.vue